/**
 * UTM Builder config — source of truth in code.
 * Server-side copy: functions/marketing/config/utmBuilderDefaults.js — keep in sync.
 */
export const UTM_BUILDER_CONFIG_VERSION = 5

export const UTM_BUILDER_DEFAULTS = {
  version: UTM_BUILDER_CONFIG_VERSION,
  channels: [
    { value: 'instagram', label: 'Instagram' },
    { value: 'facebook', label: 'Facebook' },
    { value: 'telegram', label: 'Telegram' },
    { value: 'viber', label: 'Viber' },
    { value: 'google', label: 'Google' },
    { value: 'email', label: 'Email' },
    { value: 'partner', label: 'Partner / Referral' },
    { value: 'other', label: 'Other' },
  ],
  formats: [
    { value: 'profile', label: 'Profile' },
    { value: 'story', label: 'Story' },
    { value: 'post', label: 'Post' },
    { value: 'reel', label: 'Reel' },
    { value: 'ad', label: 'Ad' },
    { value: 'banner_ad', label: 'Banner Ad' },
    { value: 'email', label: 'Email' },
    { value: 'broadcast', label: 'Broadcast' },
    { value: 'partner_post', label: 'Partner Post' },
    { value: 'other', label: 'Other' },
  ],
  directions: [
    { value: 'home', label: 'Головна' },
    { value: 'pdp', label: 'Товар / PDP' },
    { value: 'category', label: 'Категорія' },
    { value: 'brand', label: 'Бренд' },
    { value: 'outlet', label: 'Outlet' },
    { value: 'promo', label: 'Промо / Акція' },
    { value: 'landing', label: 'Landing / Custom page' },
    { value: 'other', label: 'Інше' },
  ],
  owners: [
    { value: 'kIAz8XBuTQdRoOFHfKFcgTNeE6O2', label: 'Дмитро' },
    { value: 'kRX6KumP2RgG4F2hXETsU4t6TQs1', label: 'Сніжана' },
    { value: 'RSOTdGAZtegRp6snnEYiWIGXGiu2', label: 'Олександра' },
    { value: '1uBaPmet8DQUlylFHTRnW35ypPQ2', label: 'Галя' },
    { value: '26cky9lbSieNNuHaKJqGTvnNeY83', label: 'Іванка' },
  ],
  mediumRules: [
    { channel: 'instagram', formats: ['profile', 'story', 'post', 'reel'], medium: 'social' },
    { channel: 'facebook', formats: ['profile', 'post', 'reel'], medium: 'social' },
    { channel: 'telegram', formats: ['profile', 'post', 'story'], medium: 'social' },
    { channel: 'instagram', formats: ['ad'], medium: 'paid_social' },
    { channel: 'facebook', formats: ['ad'], medium: 'paid_social' },
    { channel: 'telegram', formats: ['ad'], medium: 'paid_social' },
    { channel: 'viber', formats: ['broadcast'], medium: 'messenger' },
    { channel: 'google', formats: ['ad'], medium: 'cpc' },
    { channel: 'email', formats: ['email'], medium: 'email' },
    { channel: 'partner', formats: ['partner_post', 'banner_ad', 'post'], medium: 'referral' },
    { channel: 'other', formats: ['other'], medium: 'referral' },
  ],
  mediumDefault: 'referral',
}

export default UTM_BUILDER_DEFAULTS
